<template>
  <div class="floating-layers">

    <!-- Small Extend Banner -->
    <q-dialog v-model="extendBanner.small" seamless :position="extendBanner.direction" @mouseover="toggleExtendBanner()">
      <display-container :section="108" :no-auto-link="true" style="border-radius:0 10px 10px 0; overflow:hidden;">
        <template v-slot="{ component, row }">
          <img :src="component.getImage(row)" width="120" height="180">
        </template>>
      </display-container>
    </q-dialog>

    <!-- Big Extend Banner -->
    <q-dialog v-model="extendBanner.big" seamless position="right" v-if="extendBanner.direction === 'right'">
      <div style="position: relative; padding: 16px 0 16px 16px">
        <display-container :section="108" :use-interactive-image="true">
          <template v-slot="{ component, row }">
            <img :src="component.getImageInteractive(row)" width="300" height="300">
          </template>
        </display-container>
        <q-btn round dense color="black" icon="close" size="md" :class="`absolute-top-right`" @click="toggleExtendBanner()" />
      </div>
    </q-dialog>
    <q-dialog v-model="extendBanner.big" seamless position="left" v-else>
      <div style="position: relative; padding: 16px 16px 16px 0">
        <display-container :section="8" :use-interactive-image="true">
          <template v-slot="{ component, row }">
            <img :src="component.getImageInteractive(row)" width="300" height="300">
          </template>
        </display-container>
        <q-btn round dense color="black" icon="close" size="md" :class="`absolute-top-right`" @click="toggleExtendBanner()" />
      </div>
    </q-dialog>

    <!-- Bottom Toast Banner -->
    <div v-if="toastBanner.bottom">
      <q-dialog v-model="forceOpen2" seamless position="bottom">
        <div style="position: relative; padding: 16px 16px 0">
          <display-container :section="107" min-width="840px" min-height="100px" bg-color="bg-grey-2" class="toast-banner">
            <template v-slot="{ component, row }">
              <img :src="component.getImage(row)" width="840" height="100">
            </template>
          </display-container>
          <q-btn round dense color="black" icon="close" size="md" class="absolute-top-right" @click.stop="closeToastBanner()" />
        </div>
      </q-dialog>
    </div>

    <!-- Small Toast Banner -->
    <transition name="el-zoom-up">
      <div class="toast-banner-small" v-show="toastBanner.small">
        <display-container :section="107" :use-interactive-image="true">
          <template v-slot="{ component, row }">
            <img :src="component.getImageInteractive(row)" width="200" height="150">
          </template>
        </display-container>
      </div>
    </transition>

    <!-- Layer Banner -->
    <q-dialog v-model="layerBanner.open" persistent ref="layerBanner" @click="clickLayerBanner()">
      <div style="position: relative; padding: 16px">
        <display-container :section="106" bg-color="bg-gray-2" class="layer-banner">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)">
          </template>
        </display-container>
        <q-btn round dense color="black" icon="close" size="md" class="absolute-top-right" @click.stop="closeLayerBanner()" />
      </div>
    </q-dialog>

    <b v-model="isLoadedDisplayData"></b>

  </div>
</template>

<script>
  import {QDialog, QBtn} from 'quasar'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import { mapGetters } from 'vuex'
  export default {
    name: "FloatingLayers",
    components: {
      DisplayContainer,
      QDialog, QBtn,
    },
    data () {
      return {
        compareSlot: {
          visible: true,
          open: true
        },
        layerBanner: {
          open: false,
          click: false
        },
        toastBanner: {
          bottom: false,
          small: false
        },
        extendBanner: {
          big: false,
          small: false,
          direction: 'left'
        },
        forceOpen1: true,
        forceOpen2: true,
        notOpenExtendBannerComponentNames: [
          'Home'
        ],
        excludeLayerComponentNames: [
          'ChartView',
        ],
        showRcmdItem: false
      }
    },
    watch: {
      'isToastBannerSmallSize' (val) {
        this.toastBanner.bottom = !val
        this.toastBanner.small = val
      }
    },
    beforeUpdate () {
      this.isLoadedDisplayData
      if (this.notOpenExtendBannerComponentNames.includes(this.$route.name)) {
        this.extendBanner.big = false
        this.extendBanner.small = false
      }
    },
    computed: {
      ...mapGetters([
        'isToastBannerSmallSize'
      ]),
      getRouteName () {
        return this.$route.name
      },
      isLoadedDisplayData () {
        const rtn = this.$store.getters.getDisplayDataCnt
        if (rtn > 10) {
          this.openToastBanner()
          this.openExtendBanner()
          this.openLayerBanner()
        }
        return rtn > 10
      },
      checkExcludeLayerComponentName () {
        return !this.excludeLayerComponentNames.includes(this.$route.name)
      }
    },
    methods: {
      ...CommonMethods,
      openLayerBanner () {
        if (this.getExistDisplayDataBySectionIdx(106) && this.checkExcludeLayerComponentName) {
          if (!this.$cookies.isKey("closedLayerBanner") && !this.layerBanner.click) {
            setTimeout(function () {
              this.layerBanner.open = true
            }.bind(this), 1000)
          }
        }
      },
      closeLayerBanner () {
        this.layerBanner.open = false
        this.layerBanner.click = true
        this.$cookies.set("closedLayerBanner", true, 60 * 30)
        this.$refs.layerBanner.$destroy()
      },
      clickLayerBanner () {
        this.closeLayerBanner ()
      },
      openToastBanner () {
        if (this.getExistDisplayDataBySectionIdx(107) && this.checkExcludeLayerComponentName) {
          if (!this.$cookies.isKey("closedToastBanner") && !this.toastBanner.small) {
            setTimeout(function () {
              this.toastBanner.bottom = true
              this.$store.dispatch('setToastBannerSmallSize', false)
            }.bind(this), 1000)
          } else {
            this.toastBanner.small = true
            this.$store.dispatch('setToastBannerSmallSize', true)
          }
        }
      },
      closeToastBanner () {
        this.$cookies.set("closedToastBanner", true, 60 * 30)
        this.$store.dispatch('setToastBannerSmallSize', true)
        this.toastBanner.bottom = false
        this.toastBanner.small = true
      },
      openExtendBanner () {
        if (this.getExistDisplayDataBySectionIdx(8)) {
          if (!this.notOpenExtendBannerComponentNames.includes(this.$route.name)) {
            this.extendBanner.big = false
            this.extendBanner.small = true
          }
        }
      },
      toggleExtendBanner () {
        this.extendBanner.big = !this.extendBanner.big
        this.extendBanner.small = !this.extendBanner.small
      },
      getExistDisplayDataBySectionIdx (idx) {
        const data = this.$store.getters.getDisplayData
        return data.find(row => row.section.idx === idx)
      },
      setShowRcmd () {
        if (this.$cookies.isKey("closedRcmdItem")) return
        this.showRcmdItem = true
      },
      closeRcmdItem () {
        this.$cookies.set("closedRcmdItem", true, 60 * 30)
        this.showRcmdItem = false
      },
      isCurrentRouteName (name) {
        return this.$route.name === name
      },
    }
  }
</script>

<style>
  #compareSlot { z-index: 6008 !important;}
</style>
<style scoped>
  /deep/ .fit, .full-height {
    height: inherit !important;
  }

  /deep/ .q-carousel {
    height: inherit !important;
  }
  .q-dialog__inner--minimized>div {
    max-width: inherit !important;
    max-height: inherit !important;
  }

  .q-dialog__inner>div {
    box-shadow: inherit !important;
    background-color: transparent !important
  }

  .toast-banner-small {
    position: fixed !important;
    bottom: 0 !important;
    right: 0 !important;
    z-index: 224;
		border-radius: 5px 5px 0 0;
		overflow: hidden;
    display: none;
  }

  /deep/ .q-btn {
    z-index: 1;
  }
  /deep/ .toast-banner.display-container a img {
    max-width: 840px !important;
    max-height: 100px !important;
    width: 100% !important;
    height: 100% !important;
  }

  .layer-banner {
    -ms-overflow-style: none;
  }
  .layer-banner::-webkit-scrollbar {
    display:none;
  }
  /deep/ .layer-banner.display-container a img {
    max-width: 750px !important;
    max-height: 750px !important;
    width: 100% !important;
    height: 100% !important;
  }

  .compare_layer .big {
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 99;
    transform: translate(-50%, 0);
    width: 1220px;
    height: 80px;
    text-align: center;
    background: rgba(27, 40, 56, 0.95);
  }
  .compare_layer .big .compare_lst {
    display: inline-block;
    padding-right: 60px;
  }
  .compare_layer .big .compare_lst:after {
    display: block;
    clear: both;
    content: "";
  }
  .compare_layer .big .compare_lst li {
    float: left;
    display: table;
    width: 60px;
    height: 80px;
    margin-right: 60px;
    background: url('/statics/img/compare_lst_bg.png') no-repeat center center;
  }
  .compare_layer .big .compare_lst li .card {
    display: table-cell;
    vertical-align: middle;
  }
  .compare_layer .big .compare_lst li .card .img {
    display: inline-block;
    position: relative;
  }
  .compare_layer .big .compare_lst li .card .del_btn {
    position: absolute;
    left: calc(100% - 8px);
    top: -9px;
    height: 18px;
    text-align: left;
    background: #ffa800;
    border-radius: 9px;
    cursor: pointer;
    transition: all .15s;
  }
  .compare_layer .big .compare_lst li .card .del_btn:hover {
    background-color: #ff3f2e;
  }
  .compare_layer .big .compare_lst li .card .del_btn i {
    display: inline-block;
    width: 18px;
    height: 18px;
    font-size: 0;
    text-indent: -9999px;
    background: url('/statics/img/del_x_01.png');
  }
  .compare_layer .big .compare_lst li .card .del_btn span {
    display: inline-block;
    height: 18px;
    line-height: 16px;
    padding: 0 0 0 0px;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
  .compare_layer .big .compare_lst li.recmd {
    width: 150px;
    margin-left: -50px;
  }
  .compare_layer .big .compare_lst li.recmd .card {
    width: 150px;
    height: 80px;
    margin-left: 0px;
  }
  .compare_layer .big .compare_lst li.recmd .card .del_btn {
    width: 50px;
  }
  .compare_layer .big .compare_btn {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 38px;
    margin-top: 20px;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    background: #ffa800;
    border-radius: 3px;
    opacity: .7;
  }
  .compare_layer .big .compare_btn.on {
    opacity: 1;
    cursor: pointer;
  }
  .compare_layer .big .compare_btn.on:hover {
    background-color: #ff8400;
  }
  .compare_layer .small {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 160px;
    text-align: center;
    padding-left: 0px;
    z-index: 3;
    cursor: pointer;
  }
  .compare_layer .small:hover {
    left: 0;
  }
  .compare_layer .small .num {
    display: inline-block;
    position: relative;
    z-index: 1;
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-family: "Oswald", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 26px;
    color: #fff;
    background: #ffa800;
    border-radius: 4px;
  }
  .compare_layer .small .txt {
    line-height: 40px;
    margin-top: -15px;
    padding: 15px 0 6px;
    font-size: 15px;
    color: #fff;
    font-weight: 400;
    background: #222;
  }
</style>
